import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import { HashRouter } from "react-router-dom"
import Provider from "@store";
import axios from "axios";
axios.interceptors.request.use(function(config) {
  const token = localStorage.getItem('jwtData');
  config.headers.Authorization = `Bearer ${token}`;
  
  return config;
},
function(error) {
  // Do something with request error
  return Promise.reject(error);
}
);
axios.interceptors.response.use(function(response) {
  //获取更新的token
  const { authorization } = response.headers;
  //如果token存在则存在localStorage
  authorization && localStorage.setItem('jwtData', authorization || '');
  return response;
},
function(error) {
  if (error.response) {
    const { status } = error.response;
    //如果401或405则到登录页
    if (status === 401 || status === 405) {
      window.location.href= /127\.0\.0\.1|localhost/.test(window.location.href) ? '/#/login':'/web#/login'
      // history.push('/#/login');
    }
  }
  return Promise.reject(error);
}
);

ReactDOM.render(
  <Provider>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);
